<app-select placeholder="period_trad"
            appearance="outline"
            [disableSort]="true"
            [control]="control"
            controlName="period"
            [options]="periods"
            [valueGetter]="periodValueGetter"
            [textGetter]="periodTextGetter"></app-select>
